import React, { useCallback } from 'react';
import { StringOrNumber } from '@chakra-ui/utils';
import {
  Box,
  Checkbox,
  CheckboxGroup,
  Divider,
  Flex,
  Spacer,
  Stack,
  Tag,
  TagLabel,
  Text,
} from '@chakra-ui/react';
import { ObjectsSelectionFeature } from '../../../../types/ObjectsTypes';

export interface FeatureListProps {
  features: Array<ObjectsSelectionFeature>;
  selectedItems: StringOrNumber[];
  onFilterChange: (values: StringOrNumber[]) => void;
  header: string;
}

export const FeatureList = (props: FeatureListProps): JSX.Element => {
  const { features, selectedItems, onFilterChange, header } = props;

  const handleChange = useCallback(
    (values: StringOrNumber[]) => {
      onFilterChange(values);
    },
    [onFilterChange],
  );
  return (
    <Box>
      <Text textStyle={'category.primary'}>{header}</Text>
      <Divider mt={1} mb={4} />
      <CheckboxGroup onChange={handleChange} value={selectedItems}>
        <Stack spacing={4} direction="column">
          {features.map((feature, idx) => {
            return (
              <Flex key={idx}>
                <Checkbox size="md" colorScheme="blue" width={'100%'} value={feature.uniqueId}>
                  <Text fontSize={'md'}>{feature.Title}</Text>
                </Checkbox>
                <Spacer />
                <Tag minW={'auto'}>
                  <TagLabel >{feature.quantity}</TagLabel>
                </Tag>
              </Flex>
            );
          })}
        </Stack>{' '}
      </CheckboxGroup>
    </Box>
  );
};
